import { getItemDiscount } from '../../../../utils/item';
import { getHookCheckoutItems, setHookCheckoutItems } from '../../utils';
import { detectCartChanges, getTotalPrice, injectSubtotal } from './utils';
import { getPriceNumberFormatDefault } from '../../../../utils';

var selectors = {
  cartCount: '[data-cart-count]',
  cartCountBubble: '[data-cart-count-bubble]',
  cartDiscount: '[data-cart-discount]',
  cartDiscountTitle: '[data-cart-discount-title]',
  cartDiscountAmount: '[data-cart-discount-amount]',
  cartDiscountWrapper: '[data-cart-discount-wrapper]',
  cartErrorMessage: '[data-cart-error-message]',
  cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
  cartItem: '[data-cart-item]',
  cartItemDetails: '[data-cart-item-details]',
  cartItemDiscount: '[data-cart-item-discount]',
  cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
  cartItemDiscountTitle: '[data-cart-item-discount-title]',
  cartItemDiscountAmount: '[data-cart-item-discount-amount]',
  cartItemDiscountList: '[data-cart-item-discount-list]',
  cartItemFinalPrice: '[data-cart-item-final-price]',
  cartItemImage: '[data-cart-item-image]',
  cartItemLinePrice: '[data-cart-item-line-price]',
  cartItemOriginalPrice: '[data-cart-item-original-price]',
  cartItemPrice: '[data-cart-item-price]',
  cartItemPriceList: '[data-cart-item-price-list]',
  cartItemProperty: '[data-cart-item-property]',
  cartItemPropertyName: '[data-cart-item-property-name]',
  cartItemPropertyValue: '[data-cart-item-property-value]',
  cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
  cartItemRegularPrice: '[data-cart-item-regular-price]',
  cartItemTitle: '[data-cart-item-title]',
  cartItemOption: '[data-cart-item-option]',
  cartItemSellingPlanName: '[data-cart-item-selling-plan-name]',
  cartLineItems: '[data-cart-line-items]',
  cartNote: '[data-cart-notes]',
  cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
  cartQuantityErrorMessageWrapper: '[data-cart-quantity-error-message-wrapper]',
  cartRemove: '[data-cart-remove]',
  cartStatus: '[data-cart-status]',
  cartSubtotal: '[data-cart-subtotal]',
  cartTableCell: '[data-cart-table-cell]',
  cartWrapper: '[data-cart-wrapper]',
  emptyPageContent: '[data-empty-page-content]',
  quantityInput: '[data-quantity-input]',
  quantityInputMobile: '[data-quantity-input-mobile]',
  quantityInputDesktop: '[data-quantity-input-desktop]',
  quantityLabelMobile: '[data-quantity-label-mobile]',
  quantityLabelDesktop: '[data-quantity-label-desktop]',
  inputQty: '[data-quantity-input]',
  thumbnails: '.cart__image',
  unitPrice: '[data-unit-price]',
  unitPriceBaseUnit: '[data-unit-price-base-unit]',
  unitPriceGroup: '[data-unit-price-group]'
};

var classes = {
  cartNoCookies: 'cart--no-cookies',
  cartRemovedProduct: 'cart__removed-product',
  thumbnails: 'cart__image',
  hide: 'hide',
  inputError: 'input--error'
};

export function initCartDebutHook() {
  window.theme.Cart.prototype._createLineItemList = function(state) {
    return state.items.map(
      function(item, index) {
        var itemNode = this.itemTemplate.cloneNode(true);

        var itemPriceList = this.itemPriceListTemplate.cloneNode(true);

        this._setLineItemAttributes(itemNode, item, index);
        this._setLineItemImage(itemNode, item.featured_image);

        var cartItemTitle = itemNode.querySelector(selectors.cartItemTitle);
        cartItemTitle.textContent = item.product_title;
        cartItemTitle.setAttribute('href', item.url);

        var selling_plan_name = item.selling_plan_allocation
          ? item.selling_plan_allocation.selling_plan.name
          : null;

        var productDetailsList = this._createProductDetailsList(
          item.product_has_only_default_variant,
          item.options_with_values,
          item.properties,
          selling_plan_name
        );

        this._setProductDetailsList(itemNode, productDetailsList);

        this._setItemRemove(itemNode, item.title);

        const quantity = item.quantity;
        const discount = getItemDiscount(item);

        const originalPrice = item.original_price;
        let finalPrice = item.final_price;

        if (discount > 0) {
          finalPrice = finalPrice - (finalPrice / 100) * discount;
        }

        const totalOriginalPrice = originalPrice * quantity;
        const totalFinalPrice = finalPrice * quantity;

        itemPriceList.innerHTML = this._createItemPrice(
          originalPrice,
          finalPrice
        ).outerHTML;

        if (item.unit_price_measurement) {
          itemPriceList.appendChild(
            this._createUnitPrice(item.unit_price, item.unit_price_measurement)
          );
        }

        this._setItemPrice(itemNode, itemPriceList);

        var itemDiscountList = this._createItemDiscountList(item);
        this._setItemDiscountList(itemNode, itemDiscountList);
        this._setQuantityInputs(itemNode, item, index);

        var itemLinePrice = this._createItemPrice(
          totalOriginalPrice,
          totalFinalPrice
        );

        this._setItemLinePrice(itemNode, itemLinePrice);

        return itemNode;
      }.bind(this)
    );
  };

  window.theme.Cart.prototype._createCart = function(state) {
    const oldItems = getHookCheckoutItems();

    setHookCheckoutItems(state.items);

    const { totalPrice, originalTotalPrice } = getTotalPrice();

    var cartDiscountList = this._createCartDiscountList(state);

    var cartTable = this.container.querySelector(selectors.cartLineItems);
    cartTable.innerHTML = '';

    this._createLineItemList(state).forEach(function(lineItem) {
      cartTable.appendChild(lineItem);
    });

    this.setQuantityFormControllers();

    this.cartNotes =
      this.cartNotes || this.container.querySelector(selectors.cartNote);

    if (this.cartNotes) {
      this.cartNotes.value = state.note;
    }

    var discountWrapper = this.container.querySelector(
      selectors.cartDiscountWrapper
    );

    if (cartDiscountList.length === 0) {
      discountWrapper.innerHTML = '';
      discountWrapper.classList.add(classes.hide);
    } else {
      discountWrapper.innerHTML = '';

      cartDiscountList.forEach(function(discountItem) {
        discountWrapper.appendChild(discountItem);
      });

      discountWrapper.classList.remove(classes.hide);
    }

    // Subtotal update
    injectSubtotal({
      subtotalOriginal: originalTotalPrice,
      subtotal: totalPrice
    });

    // Update cart items.
    detectCartChanges(oldItems, state.items);
  };
}

export function injectDebutLineSubotal({ iter, cost, totalPrice }) {
  const jUpsell = window.jUpsell;

  // ITEM
  // Remove regular price.
  jUpsell(
    `.cart__row:nth-child(${iter}) 
            > td:nth-child(2) 
            > div:first 
            > dl
            > div:nth-child(2)`
  ).addClass('hide');

  // Show discount
  jUpsell(
    `.cart__row:nth-child(${iter}) 
            > td:nth-child(2) 
            > div:first 
            > dl
            > div:nth-child(1)`
  ).removeClass('hide');

  // Update discount
  jUpsell(
    `.cart__row:nth-child(${iter}) 
            > td:nth-child(2) 
            > div:first 
            > dl 
            > div:nth-child(1) 
            > dd:nth-child(4)  
            > span`
  ).text(getPriceNumberFormatDefault(cost));

  // TOTAL
  // Remove regular total
  jUpsell(
    `.cart__row:nth-child(${iter}) 
            > td:nth-child(4) 
            > div`
  ).addClass('hide');

  // Show discount total
  jUpsell(
    `.cart__row:nth-child(${iter}) 
            > td:nth-child(4) 
            > dl`
  ).removeClass('hide');

  // Update discount total
  jUpsell(
    `.cart__row:nth-child(${iter}) 
            > td:nth-child(4) 
            > dl
            > dd
            > span`
  ).text(getPriceNumberFormatDefault(totalPrice));
}
